<template>
  <nx-fullscreen-dialog :title="blockTitle" :active="active" @dismiss="dismiss">
    <v-btn
      slot="toolbar-items"
      color="accent"
      flat
      :disabled="!isValid"
      @click="insertBlot"
    >{{ buttonTitle }}</v-btn>
    <template>
      <v-container grid-list-xs pb-3>
        <v-layout>
          <v-flex offset-md2 md8 pt-4>
            <h2 class="nx-block-headline">{{ formTitle }}</h2>

            <v-text-field
              autofocus
              @input="handleUrl"
              :value="data.url"
              :label="instagramTitle"
              :placeholder="placeholderTitle"
              :error-messages="error"
            ></v-text-field>

            <v-switch
              v-model="data.includeCaption"
              :label="$t('message.editor.embed.instagramIncludeCaption')"
            ></v-switch>

            <div class="ql-wrapper-text">
              <iframe
                v-if="previewUrl"
                :src="previewUrl"
                allowfullscreen
                frameborder="0"
                height="440"
                width="320"
              ></iframe>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </nx-fullscreen-dialog>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import DialogButton from './DialogButton';

/**
 * InstagramButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-instagram-button',
  extends: DialogButton,
  props: {
    embedUrl: String,
    embedIncludeCaption: {
      type: String, // Bool has string because attributtes can't be false
      default: 'true',
    },
  },
  data() {
    return {
      name: 'instagramEmbed',
      data: {
        url: this.embedUrl || '',
        includeCaption: this.embedIncludeCaption === 'true',
      },
    };
  },

  methods: {
    handleUrl($url) {
      this.data.url = $url.split('?')[0];
    },
  },


  computed: {
    blockTitle() {
      return this.$t('message.block.instagram');
    },
    instagramTitle() {
      return this.$t('message.block.form.instagram.title');
    },
    placeholderTitle() {
      return this.$t('message.block.form.instagram.placeholder');
    },
    isValid() {
      return (
        !!this.data.url || this.data.url.includes('instagram') || !this.error
      );
    },
    previewUrl() {
      if (!this.isValid) {
        return null;
      }
      if (this.data.url.endsWith('/')) {
        return `${this.data.url}embed`;
      }
      return `${this.data.url}/embed`;
    },
  },
};
</script>
